module.exports = __webpack_public_path__ + "static/media/write(gray).59ae6264.svg";